import React from 'react'

export const KeyValueItem = props => {
  const { label, value } = props || {}

  return (
    <div>
      <p
        style={{
          marginBottom: '4px',
          fontSize: '12px',
          fontWeight: 'normal',
          color: '#1D2630',
          opacity: '0.7',
        }}>
        {label}
      </p>
      <div
        style={{
          fontSize: '14px',
          fontWeight: 'medium',
        }}>
        {value}
      </div>
    </div>
  )
}
